<div class="card min-w-[380px]  md:min-w-[480px] lg:min-w-[520px]">
  <h2 class="mt-4 font-bold text-2xl">Inicio de sesión</h2>
  <form [formGroup]="loginForm" class="mt-8 flex flex-col gap-5" (ngSubmit)="onSubmit()">
    <div class="flex flex-col gap-1">
      <input
        class="w-full"
        type="text"
        pInputText
        formControlName="email"
        placeholder="Email"
      />
      <p-message
        *ngIf="isValidField('email')"
          severity="error"
        >Formato de email incorrecto</p-message>        
    </div>
    <div class="flex flex-col gap-1">
      <p-password
        styleClass="w-full"
        formControlName="password"
        [feedback]="false"
        [toggleMask]="true"
        placeholder="Contraseña"
      ></p-password>
        <p-message
        *ngIf="isValidField('password')"
          severity="error"
        >La contraseña es necesaria</p-message>
      </div>
    <div class="flex mt-2 justify-end">
      <a class="cursor-pointer" (click)="forgottenPassword()">¿Contraseña olvidada?</a>
    </div>
    <div class="mt-12">
      <p-button
      [raised]="true"
        [disabled]="!loginForm.valid"
        type="submit"
        label="Iniciar sesión"
        styleClass="w-full"
      ></p-button>
    </div>
  </form>
</div>

<p-toast></p-toast>
